import { motion } from "framer-motion";
import { APP_SHOTS } from "../../data/site";

const ease = [0.22, 1, 0.36, 1];

const Phone = ({ item, i }) => (
  <motion.div
    initial={{ opacity: 0, y: 60 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease, delay: i * 0.12 }}
    className={`relative ${i === 1 ? "md:-translate-y-10" : ""}`}
    data-testid={`showcase-phone-${i}`}
  >
    <div className="relative mx-auto aspect-[9/19.5] w-full max-w-[15rem] overflow-hidden rounded-[2.6rem] border border-white/12 bg-black p-1.5 shadow-[0_30px_80px_-20px_rgba(79,70,229,0.35)]">
      <img
        src={item.src}
        alt={`Radiate app — ${item.label}`}
        className="h-full w-full rounded-[2.2rem] object-cover object-top"
      />
    </div>
    <div className="mt-6 text-center">
      <p className="font-display text-lg font-light text-white">{item.label}</p>
      <p className="mt-1 text-xs text-white/45">{item.caption}</p>
    </div>
  </motion.div>
);

export const Showcase = () => (
  <section
    id="app"
    className="relative z-10 mx-auto max-w-7xl px-6 py-24 md:px-10 md:py-32"
    data-testid="showcase-section"
  >
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.9, ease }}
      className="mb-16 max-w-3xl md:mb-24"
    >
      <p className="mb-6 text-xs font-semibold uppercase tracking-[0.35em] text-white/40">
        Built around real life
      </p>
      <h2 className="font-display text-4xl font-extralight leading-tight tracking-tight text-white md:text-6xl">
        Every session meets you where you{" "}
        <span className="italic text-white/70">actually are.</span>
      </h2>
      <p className="mt-6 max-w-xl text-base leading-relaxed text-white/50 md:text-lg">
        Not a quiet room you don't have. Radiate is built for the walk between
        meetings, the five minutes before your day starts, the moment you need
        to come back to yourself.
      </p>
    </motion.div>

    <div className="grid grid-cols-1 gap-12 sm:grid-cols-3 sm:gap-6 md:gap-10">
      {APP_SHOTS.map((p, i) => (
        <Phone key={i} item={p} i={i} />
      ))}
    </div>
  </section>
);
